import React from "react"

export default (color: string) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="19.993"
    viewBox="0 0 20 19.993"
  >
    <g id="noun_reload_2625901" transform="translate(-2 -2.004)">
      <path
        id="Path_305"
        data-name="Path 305"
        d="M21.06,12a1,1,0,0,0-1.1.88,8,8,0,0,1-13.39,5l2.15-2.15A1,1,0,0,0,8,14H3a1,1,0,0,0-1,1v5a1,1,0,0,0,1.71.71l1.44-1.44a10,10,0,0,0,16.8-6.16A1,1,0,0,0,21.06,12Z"
        fill={`${color}`}
      />
      <path
        id="Path_306"
        data-name="Path 306"
        d="M21.38,3.08a1,1,0,0,0-1.09.22L18.86,4.73a10,10,0,0,0-16.8,6.16A1,1,0,0,0,2.94,12h.11a1,1,0,0,0,1-.89,8,8,0,0,1,13.39-5L15.29,8.29A1,1,0,0,0,16,10h5a1,1,0,0,0,1-1V4a1,1,0,0,0-.62-.92Z"
        fill={`${color}`}
      />
    </g>
  </svg>
)
